
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystacabforcorporateoffice() {



    const cardData =
    {
        keyword: 'Innova Crysta Cab for Corporate Office',
        heading: 'Meghana Cab : Innova Crysta Cab for Corporate Office',
        headingDescription: 'Meghana Cab offers Innova Crysta Cab for Corporate Office transportation, tailored to meet the premium travel needs of executives, employees, and business associates. Whether it is daily office commute, airport transfers, client pickups, or outstation meetings, our Innova Crysta vehicles provide unmatched comfort with plush interiors, ample space, air-conditioning, and top-notch safety features. Ideal for corporate teams, our cabs come with professional chauffeurs, punctual service, and customizable billing options. With transparent pricing, 24/7 support, and seamless booking, Meghana Cab ensures your business travel is efficient, comfortable, and professional. Book your Innova Crysta for Corporate Travel with Meghana Cab and elevate your company’s transportation experience.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic 18th-century fortification built in 1732 by the Peshwas of the Maratha Empire. Once a grand seven-story palace complex, it was the seat of power for the Marathas until it was largely destroyed by a fire in 1828. Today, its majestic stone walls, Delhi Gate, fountains, garden courtyards, and haunting legends attract history lovers and curious travelers alike. The light-and-sound show held in the evenings vividly narrates the glory, politics, and drama of the Maratha reign, offering an immersive dive into Pune's regal past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892 by Sultan Aga Khan III, this palatial structure played a significant role in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai following the launch of the Quit India Movement. Today, the palace stands as a serene museum preserving personal artifacts of the Gandhis, including letters, utensils, and photographs. Its lush gardens and Italian-style arches make it a peaceful, contemplative retreat and a symbol of national pride."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a cliff about 1,317 meters above sea level, Sinhagad Fort is a popular trekking destination and a monument of immense historical importance. It was the site of the legendary Battle of Sinhagad in 1670, where Tanaji Malusare sacrificed his life for the Maratha Empire. The fort offers sweeping views of the Sahyadri hills, rustic village-style food stalls serving pithla-bhakri, and remains of old ramparts, watchtowers, and gates. It’s a must-visit for adventure seekers, history buffs, and those looking for a scenic monsoon getaway."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in the leafy Koregaon Park area, the Osho Ashram is a globally renowned spiritual and wellness retreat. Spanning 28 acres of landscaped gardens, modern Zen architecture, and marble meditation halls, the center offers unique active meditations, wellness therapies, and spiritual workshops. Attracting thousands of visitors from around the world, it blends luxury with mindfulness, offering a tranquil escape from the city's chaos. Whether you're seeking inner peace, silence, or global community interaction, Osho's Pune campus is a one-of-a-kind experience."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the highest natural points in Pune, offering panoramic views of the city skyline and surrounding hills. A flight of 103 stone steps leads to the Peshwa-era Parvati Temple, dedicated to Goddess Parvati, along with shrines of Vishnu, Ganesha, and Kartikeya. The hilltop also houses a small museum showcasing Maratha artifacts. This peaceful locale is a favorite among morning joggers, photographers, and devotees seeking both spiritual calm and a bird’s-eye view of Pune."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum is a treasure trove of Indian decorative arts and everyday objects from the 17th to 20th centuries. Curated by Dr. Dinkar Kelkar in memory of his son, the museum houses over 20,000 artifacts, including musical instruments, ancient weapons, wooden doors, utensils, and intricate sculptures. The highlight is the recreated ‘Mastani Mahal’, reflecting royal Maratha grandeur. Its interactive galleries and multilingual audio tours make it a cultural gem for anyone interested in India’s rich domestic and artisan history."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "This highly revered Ganesh temple in Budhwar Peth is over 125 years old and attracts lakhs of devotees, especially during Ganesh Chaturthi. The temple houses a 7.5-foot-tall, gold-adorned idol of Lord Ganesha, surrounded by ornate silver and gold decorations. It was built by sweet merchant Dagdusheth Halwai and is known not just for its spiritual ambiance, but also for its charity work and cultural events. Its accessibility and aura make it a daily stop for Puneites and tourists alike."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An ancient 8th-century rock-cut cave temple carved out of a single basalt rock, Pataleshwar is dedicated to Lord Shiva and features a sanctum sanctorum with a Shiva linga, a circular Nandi mandapa, and intricately carved columns. Tucked away on Jangli Maharaj Road amidst modern buildings, the temple is a peaceful and surprisingly well-preserved example of Indian monolithic architecture. It’s a serene spot for meditation and a must-visit for heritage lovers."
  },
  {
    "title": "Shinde Chhatri",
    "description": "Shinde Chhatri is a royal memorial dedicated to Mahadji Shinde, a great Maratha commander in the 18th century. Located in Wanowrie, the monument is a blend of Rajasthani and Indo-Saracenic architecture, adorned with stained-glass windows, ornate pillars, and carved domes. The tranquil complex also houses a temple and the warrior’s samadhi. Its lesser-known status makes it a peaceful place to explore Pune’s forgotten royal heritage."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spanning over 130 acres, this modern zoological park in Katraj houses a diverse range of animals including white tigers, elephants, sloth bears, reptiles, and exotic birds. It also includes a well-maintained snake park with educational exhibits. The adjoining Katraj Lake adds scenic value, and the park's clean pathways and greenery make it a favorite for families and children. Conservation programs and animal adoption initiatives are also part of the park’s ecological mission."
  }
],

"services": [
  {
    "name": "Corporate Innova Crysta Cab Pune",
    "description": "Elevate your corporate travel experience in Pune with our premium Innova Crysta cabs. Designed to provide executive comfort, punctuality, and professional service, ideal for client meetings, business events, and daily office commutes."
  },
  {
    "name": "Business Innova Crysta Taxi Pune",
    "description": "Choose our business Innova Crysta taxi service in Pune for seamless travel to meetings, conferences, and corporate events. Enjoy spacious interiors, reliable pickups, and chauffeurs trained in professionalism and discretion."
  },
  {
    "name": "Office Travel Innova Crysta Cab Pune",
    "description": "Make your daily office commute comfortable and stress-free with our office travel Innova Crysta cab service in Pune. Flexible booking options, timely service, and well-maintained vehicles ensure you arrive fresh and on time."
  },
  {
    "name": "Chauffeur Driven Corporate Innova Crysta Pune",
    "description": "Relax and focus on your work while our professional chauffeurs drive you around Pune in a premium Innova Crysta. Our chauffeur-driven corporate service guarantees safety, privacy, and a luxurious ride tailored for business travelers."
  },
  {
    "name": "Corporate Event Innova Crysta Cab Booking Pune",
    "description": "Book Innova Crysta cabs for corporate events in Pune with ease. Our reliable fleet and experienced drivers ensure smooth transportation for team outings, client visits, and conferences, delivering impeccable service every time."
  },
  {
    "name": "Corporate Outstation Innova Crysta Hire Pune",
    "description": "Plan your corporate outstation travel from Pune with our Innova Crysta hire service. Enjoy a blend of comfort, efficiency, and professionalism for business trips, airport transfers, and multi-city tours with flexible packages."
  },
  {
    "name": "Budget Corporate Innova Crysta Taxi Pune",
    "description": "Access premium corporate travel without overspending with our budget-friendly Innova Crysta taxi service in Pune. Perfect for startups and small businesses, this service balances cost-efficiency with comfort and reliability."
  },
  {
    "name": "Premium Corporate Innova Crysta Cab Pune",
    "description": "Experience luxury and exclusivity with our premium corporate Innova Crysta cabs in Pune. Equipped with executive seating and modern amenities, this service caters to top-level executives and VIP clients demanding the highest standards."
  }
],
"tableData": [
  ["Corporate Innova Crysta Cab Pune", "Business Innova Crysta Taxi Pune"],
  ["Office Travel Innova Crysta Cab Pune", "Chauffeur Driven Corporate Innova Crysta Pune"],
  ["Corporate Event Innova Crysta Cab Booking Pune", "Corporate Outstation Innova Crysta Hire Pune"],
  ["Budget Corporate Innova Crysta Taxi Pune", "Premium Corporate Innova Crysta Cab Pune"]
],



"whychoose": [
    {
        "WhyChooseheading": "Professional Innova Crysta Cab Service for Corporate Offices",
        "WhyChoosedescription": "Our Innova Crysta cabs offer a premium commuting solution for corporate employees, combining comfort, punctuality, and professionalism. Ideal for daily office travel, client meetings, and corporate events."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Interiors",
        "WhyChoosedescription": "The Innova Crysta provides ample space for passengers and their belongings, ensuring a relaxed and comfortable journey to and from the office. Its ergonomic seating and smooth ride reduce travel fatigue."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our professional drivers are trained to maintain confidentiality, follow corporate protocols, and navigate efficiently through traffic, ensuring timely arrivals and a hassle-free commute."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "We prioritize cleanliness and vehicle maintenance, ensuring every Innova Crysta cab is sanitized and in optimal condition to provide a safe and pleasant travel environment for corporate clients."
    },
    {
        "WhyChooseheading": "Flexible Scheduling and Customized Routes",
        "WhyChoosedescription": "Tailor your cab bookings according to your office hours, meetings, and client visits. We offer flexible pickup and drop-off points and can accommodate last-minute schedule changes."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Corporate Packages",
        "WhyChoosedescription": "Enjoy competitive rates with clear, all-inclusive pricing. We also offer customized corporate packages and monthly billing options to simplify your company’s transportation management."
    },
    {
        "WhyChooseheading": "Dedicated Customer Support for Corporate Clients",
        "WhyChoosedescription": "Our support team is available 24/7 to assist with bookings, itinerary adjustments, and special requests, providing seamless service to meet your corporate transportation needs."
    },
    {
        "WhyChooseheading": "Ideal for Employee Commutes, Business Meetings, and Events",
        "WhyChoosedescription": "Whether for daily commutes, off-site meetings, or corporate events, our Innova Crysta cabs deliver reliable, comfortable, and professional transport solutions tailored to your business."
    }
]




















    }

const faqData = [
    {
        question: "Can I book an Innova Crysta cab for corporate office travel?",
        answer: "Yes, Meghana Cab offers Innova Crysta rentals for daily employee commutes, business meetings, and corporate events."
    },
    {
        question: "Is Innova Crysta a good option for corporate travel needs?",
        answer: "Absolutely. With spacious seating, air-conditioning, and professional drivers, it’s perfect for executives and staff."
    },
    {
        question: "How do I book an Innova Crysta for my office or company?",
        answer: "You can call Meghana Cab at +91 9075462128 or use our website to set up regular or one-time bookings for your office."
    },
    {
        question: "Are monthly rental packages available for corporate cabs?",
        answer: "Yes, we offer flexible daily, weekly, and monthly rental plans tailored to corporate requirements."
    },
    {
        question: "Are the cabs sanitized before corporate use?",
        answer: "Yes, all Innova Crysta cabs are thoroughly cleaned and sanitized before every trip for health and safety."
    },
    {
        question: "Can I get billing and invoice support for corporate payments?",
        answer: "Yes, we provide GST-compliant invoices and support multiple payment modes suitable for businesses."
    },
    {
        question: "Do you offer pickup and drop services for multiple employees?",
        answer: "Yes, we can coordinate scheduled pickups and drops for teams or individual employees across locations."
    },
    {
        question: "Are your drivers trained for corporate cab services?",
        answer: "Yes, our drivers are professionally trained, punctual, and maintain proper dress code and behavior."
    },
    {
        question: "Is the Innova Crysta available for outstation corporate travel?",
        answer: "Yes, we offer outstation cab services for business trips, conferences, and corporate events."
    },
    {
        question: "What payment methods are accepted for corporate bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and corporate account payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Kulkarni',
        designation: 'Admin Manager, IT Firm',
        rating: [1, 1, 1, 1, 1],
        text: '“We use Meghana Cab’s Innova Crysta for our executives. Always on time, clean cars, and excellent driver conduct.”',
    },
    {
        name: 'Ms. Shraddha Nene',
        designation: 'HR Executive',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth coordination for daily office transport. Our team really appreciates the comfort of the Innova Crysta.”',
    },
];










































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const corporateInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Crysta Cab for Corporate Office Travel in Pune",
  "description": "Premium chauffeur-driven Innova Crysta taxi service for corporate office travel in Pune. Ideal for business trips, corporate events, and outstation travel. Affordable and reliable corporate cab hire.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Corporate Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/corporate-innova-crysta-cab-pune"
  }
};









    return (
        <div>

<Helmet>
  <title>Corporate Innova Crysta Cab in Pune | Business Taxi Service</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta cabs for corporate office travel, business trips, and events in Pune. Affordable and premium corporate taxi service."
  />
  <meta
    name="keywords"
    content="Corporate Innova Crysta Cab Pune, Business Innova Crysta Taxi Pune, Office Travel Innova Crysta Cab Pune, Chauffeur Driven Corporate Innova Crysta Pune, Corporate Event Innova Crysta Cab Booking Pune, Corporate Outstation Innova Crysta Hire Pune, Budget Corporate Innova Crysta Taxi Pune, Premium Corporate Innova Crysta Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(corporateInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystacabforcorporateoffice;